interface IPlusIconProps {
  className?: string;
  size?: string;
}

const PlusIcon = ({ className, size }: IPlusIconProps) =>
<svg id="plusicon__assets-icons-v2__svg__l7"
xmlns="http://www.w3.org/2000/svg"
width={size}
height={size}
viewBox="0 0 24 24"
fill="none"
stroke="currentColor"
strokeWidth="2"
strokeLinecap="round"
strokeLinejoin="round"
className={className}>
  
    <path id="plusicon__assets-icons-v2__path__l19" stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path id="plusicon__assets-icons-v2__path__l20" d="M12 5l0 14" />
    <path id="plusicon__assets-icons-v2__path__l21" d="M5 12l14 0" />
  </svg>;


export default PlusIcon;